module.exports = __webpack_public_path__ + "img/french.b2c4fa22.png";